import { useEffect, useRef, memo } from "react";

function TickerTapeWidget({ theme }) {
  const container = useRef();

  useEffect(() => {
    if (!container.current || !theme) return;

    const timeout = setTimeout(() => {
      container.current.innerHTML = "";

      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
      {
        "symbols": [
          { "proName": "COINBASE:BTCUSD","title": "Bitcoin" },
          { "proName": "COINBASE:ETHUSD","title": "Ethereum" },
          { "proName": "COINBASE:USDTUSD","title": "USDT" },
          { "proName": "COINBASE:XRPUSD","title": "XRP" },
          { "proName": "COINBASE:USDTUSDC", "title": "USDC" }
        ],
        "colorTheme": "${theme}",
        "isTransparent": false,
        "displayMode": "adaptive",
        "locale": "en"
      }
    `;
      if (container.current) {
        container.current.appendChild(script);
      }
    }, 0);
    return () => clearTimeout(timeout); // Clean up
  }, [theme]);

  return (
    <div
      className="w-full mb-4 overflow-hidden rounded-sm shadow-box-shadow border border-background-surface"
      ref={container}
    >
      <div className="tradingview-widget-container__widget" />
    </div>
  );
}

export default memo(TickerTapeWidget);
